import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Alert } from '@material-ui/lab';
import { api, ConfigFieldControl } from '@sierralabs/core-ui';
import { EntityPicker } from '@sierralabs/entity-ui';
import { TaskStatusActions, useTaskEntityData } from '@sierralabs/workflow-ui';
import SiteRouteAndParamPicker, { updateRouteAndParam } from '../../common/pickers/SiteRouteAndParamPicker';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
const StyledAlert = styled(Alert) `
  padding-top: 0;
  padding-bottom: 0;
`;
export const SiteTaskStatusActions = props => {
    const component = useSubscribeComponentChanges(SiteTaskStatusActionsPlugin, props);
    const { editing, isHover, hoverProps } = useSiteContext();
    const classes = ['site-task-status-actions'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const { entityId, entityTable, routeParam } = component.props || {};
    const params = useParams();
    const dataId = routeParam ? params[routeParam] : undefined;
    const { task, entityData, isLatest } = useTaskEntityData(entityId || entityTable || '', dataId);
    const showActions = !!(task && entityData);
    const content = (React.createElement(React.Fragment, null,
        editing && !showActions && (React.createElement(StyledAlert, { severity: 'info' }, "Task Status Actions are displayed here.")),
        task && entityData && (React.createElement(TaskStatusActions, { task: task, taskEntity: entityData, disabled: editing || !isLatest, containerProps: hoverProps(component) }))));
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteTaskStatusActionsPlugin }, props), editing ? (React.createElement("div", Object.assign({ className: classes.join(' ') }, hoverProps(component)), content)) : (content)));
};
export const SiteTaskStatusActionsConfigurator = props => {
    var _a, _b, _c, _d;
    const { component, remove, update } = useConfigComponent(props.component);
    const taskConfig = api.getEntity('task', 'Task');
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteRouteAndParamPicker, { nearestOnly: true, component: component, routeId: (_a = component.props) === null || _a === void 0 ? void 0 : _a.routeId, routeParam: (_b = component.props) === null || _b === void 0 ? void 0 : _b.routeParam, siteRoutePickerProps: {
                label: 'Entity Detail Route',
                placeholder: 'Path for Entity detail page'
            }, onChange: value => {
                updateRouteAndParam(value, 'props.routeId', 'props.routeParam').forEach(([path, value]) => update(path, value));
            } }),
        React.createElement(ConfigFieldControl, null,
            React.createElement(EntityPicker, { fullWidth: true, variant: 'standard', label: 'Task Entity', placeholder: 'Select the Task Entity', InputProps: { disableUnderline: true }, value: ((_c = component.props) === null || _c === void 0 ? void 0 : _c.entityId) || ((_d = component.props) === null || _d === void 0 ? void 0 : _d.entityTable), filter: entity => {
                    return (entity.relations || []).some(relation => relation.propertyName === taskConfig.propertyName);
                }, onChange: entity => {
                    if (!entity) {
                        remove('props.entityId');
                        remove('props.entityTable');
                        return;
                    }
                    const prop = entity.id ? 'entityId' : 'entityTable';
                    update(`props.${prop}`, entity.id || entity.tableName);
                } }))));
};
export const SiteTaskStatusActionsPlugin = {
    name: 'Task Status Actions',
    type: 'site-task-status-actions',
    component: SiteTaskStatusActions,
    configurator: SiteTaskStatusActionsConfigurator
};
//# sourceMappingURL=SiteTaskStatusActionsPlugin.js.map